import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { storeToRefs } from 'pinia';
import { computed, defineComponent } from 'vue';
import { useAuthStore } from '@/store/authStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'CertifiedPartner',
  setup: function setup(__props) {
    defineComponent({
      name: 'CertifiedPartner'
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      user = _storeToRefs.user;
    var isCertifiedPartner = computed(function () {
      var _user$value;
      return (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.is_certified_agent;
    });
    return {
      __sfc: true,
      authStore: authStore,
      user: user,
      isCertifiedPartner: isCertifiedPartner,
      SIcon: SIcon
    };
  }
});